import useGlobalToast from '@centric-os/components/src/core/messages/toast/composables/use-global-toast';
import { useI18n } from 'vue-i18n';

/**
 * EN/FR copy for calendar PUT 409 (optimistic locking). Use in setup/composables or Vue SFCs when catching {@link CalendarRevisionConflictError}.
 */
export default function useCalendarRevisionConflictFeedback() {
  const { t } = useI18n();
  const { showErrorToast } = useGlobalToast();

  const showCalendarRevisionConflictToast = (): void => {
    showErrorToast(
      t('sites.schedule.sidePanel.menuSchedulePanel.calendarRevisionConflictTitle'),
      t('sites.schedule.sidePanel.menuSchedulePanel.calendarRevisionConflictDetail'),
    );
  };

  return { showCalendarRevisionConflictToast };
}
